import { WebApiRequest, HTTP_GET, WebApiReduxRequest, HTTP_POST } from "tools/webservice";
import { api } from "apis/collateralAnalytics";
import { REQUEST_RISK_PROFILER_RESULTS,
  RECEIVE_RISK_PROFILER_RESULTS,
  ERROR_RETRIEVING_RISK_PROFILER_RESULTS } from "typeConstants";

export const generateSsoParameters = (controlNumber, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: api.generateSsoParameters(controlNumber),
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });
};

export const generateSsoParametersRiskProfiler = (controlNumber, successCallback, errorCallback, mountedRef) => {
  WebApiRequest({
    method: HTTP_GET,
    endpoint: api.generateSsoParametersRiskProfiler(controlNumber),
    mountedRef: mountedRef,
    successCallback: successCallback,
    errorCallback: errorCallback
  });
};

export const getRiskProfilerResults = (controlNumber, successCallback, errorCallback, mountedRef) => WebApiReduxRequest(
  REQUEST_RISK_PROFILER_RESULTS,
  RECEIVE_RISK_PROFILER_RESULTS,
  ERROR_RETRIEVING_RISK_PROFILER_RESULTS,
  HTTP_GET,
  api.riskProfilerResults(controlNumber),
  successCallback,
  errorCallback,
  mountedRef,
);

export const submitRiskProfilerResults = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: api.riskProfilerResults(controlNumber),
  successCallback: successCallback,
  mountedRef: mountedRef
});